import { gql } from '@/__generated__';
import { UpdateTagsModal_DevicesListQuery } from '@/__generated__/graphql';

export type InternalDevice = UpdateTagsModal_DevicesListQuery['devices'][number];

const GET_UPDATE_TAGS_DEVICES_LIST = gql(`#graphql
  query UpdateTagsModal_DevicesList {
    devices(input: { orderBy: ID_ASC, includeGates: true }) {
      id
      profile {
        id
        name
        type
        operationalState
        organization {
          id
          name
        }
        tags {
          tag
        }
      }
    }
  }
`);

export default GET_UPDATE_TAGS_DEVICES_LIST;
